import { expected } from '@aloft/toolkit-shared';

import { useParams } from 'react-router';

import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { FeatureGridModule } from '../../modules/featureGrid/FeatureGridModule.tsx';
import { PropertyComparisonGridSyncDriver } from '../OrderSync/PropertyComparisonGridSyncDriver.tsx';

export const FeatureGridRouteElement = () => {
  const orderId = expected(useParams().orderId);

  return (
    <PropertyComparisonGridSyncDriver orderID={orderId}>
      <ModuleContainer moduleID="analysis" compact>
        <FeatureGridModule />
      </ModuleContainer>
    </PropertyComparisonGridSyncDriver>
  );
};
